import { h } from 'preact'

export const ParcoursNouveauteInternet = (props) => {
   const { title, image, alt, cards } = props
   return (
      <section id="parcours-nouveaute-internet" data-testid="bande-parcours-nouveautes-internet" class="parcours-nouveaute-internet">
         <div class="container-fluid">
            <h2 class="mb-0">{title}</h2>
         </div>

         <div class="content mb-3">

            <img src={`${image}?saveas=webp`} alt={alt} class="visuel" loading="lazy" />

            <div class="container-fluid">
               <div class="row">
                  {cards.map((cardData, index) => (
                     <Card {...cardData} index={index + 1} />
                  ))}
               </div>
            </div>
         </div>
      </section>
   )
}

const Card = (props) => {
   const { badge, description, CTA, index } = props
   return (
      <div class="card-wrap col-12 col-md-4 mb-1" data-testid={`parcoursNouveautesInternet${index}`}>
         <div class="ob1-card bg-white lien-composite-before p-2 h-100">
            {badge !== '' ? <span class="ob1-tag ob1-tag-primary">{badge}</span> : ''}
            <p class="lead mb-0">{description}</p>
            <a
               href={CTA.URL}
               class="o-link-arrow"
               data-pdb-zid={CTA.analytics.pdbZid}
               data-pdb-sc={CTA.analytics.pdbSc}
               data-pdb-idc={CTA.analytics.pdbIdc}
               data-pdb-vi={CTA.analytics.pdbVi}
               data-oevent-category={CTA.analytics.oeventCategory}
               data-oevent-action={CTA.analytics.oeventAction}
               data-oevent-label={CTA.analytics.oeventLabel}
               data-oevent-other={CTA.analytics.oeventOther}
            >
               {CTA.label}
            </a>
         </div>
      </div>
   )
}
